var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      _c(
        "el-upload",
        {
          ref: "upload",
          staticClass: "uploader",
          attrs: {
            data: { siteId: _vm.getSite.siteId },
            action: _vm.actionUrl,
            headers: _vm.headers,
            accept: _vm.actionUrl,
            "show-file-list": false,
            "on-success": _vm.handleAvatarSuccess,
            "before-upload": _vm.beforeAvatarUpload,
          },
        },
        [
          _c("el-input", {
            attrs: { readonly: "", "suffix-icon": "el-icon-folder-opened" },
            model: {
              value: _vm.imageName,
              callback: function ($$v) {
                _vm.imageName = $$v
              },
              expression: "imageName",
            },
          }),
        ],
        1
      ),
      _c("el-input", {
        staticClass: "textarea",
        attrs: {
          type: "textarea",
          rows: 6,
          maxlength: "1000",
          "show-word-limit": "",
          placeholder: _vm.$t("NEW_COMMENT"),
        },
        model: {
          value: _vm.content,
          callback: function ($$v) {
            _vm.content = $$v
          },
          expression: "content",
        },
      }),
      _c(
        "div",
        { staticClass: "wl-btn-container" },
        [
          _c(
            "el-button",
            { staticClass: "wl-grey", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")) + "\n    ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { loading: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.onSend(_vm.content, _vm.pid)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("comment_send")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }